import { Injectable } from '@angular/core';
import { PartnerInformation } from '../../core-data-model/PartnerInformation/partner-information.model';
import { PartnerInformationServer } from '../../core-data-model/PartnerInformation/partner-information.serverinterface';

@Injectable({ providedIn: 'root' })
export class PartnerInformationTransformer {
    transformPartnerInformationServerToClient(
        server: PartnerInformationServer
    ): PartnerInformation {
        return {
            companyName: server.forcePartnerName,
            fullName: server.forcePartnerContactName,
            email: server.forcePartnerContactEmail,
            phone: server.forcePartnerContactPhone,
            isDirectClient: server.forcePartnerIsDirect,
            accountMetadata: server.forceAccountMetadata
        };
    }
}
